import React, { ComponentPropsWithRef } from "react";
import { Modal } from "antd";
import "./Modal.scss";
import cn from "clsx";
import { useToggle } from "../Context/NavbarContext";

type ReusableModalProps = ComponentPropsWithRef<typeof Modal> & {
  isModalOpen: boolean;
  handleModal: () => void;
  children: React.ReactNode;
  title?:React.ReactNode;
  subtitle?: React.ReactNode;
  footer?: React.ReactNode;
  contentClassName?: string;
};

const ReusableModal = ({
  isModalOpen,
  handleModal,
  title,
  children,
  className,
  subtitle,
  footer,
  contentClassName,
  ...modalProps
}: ReusableModalProps) => {
  const { isTrue, toggle } = useToggle();

  const handleCancel = () => {
    if (isTrue) {
      toggle();
    }
    handleModal();
  };

  return (
    <Modal
      centered
      open={isModalOpen}
      onCancel={handleCancel}
      footer={footer || false}
      title={
        (title || subtitle) && (
          <div className={"titleWrapper"}>
            <p className={"title"}>{title}</p>
            <p className={"subtitle"}>{subtitle}</p>
          </div>
        )
      }
      className={cn("confirmationModalContainer", className)} // Combine classNames here
      {...modalProps}
    >
      <div
        data-testid={`confirmationModal-testId`}
        className={cn("contentContainer", contentClassName)}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {children}
      </div>
    </Modal>
  );
};

export default ReusableModal;
